const _ingredients = [
  {
    name: 'Flour',
    hydration: 0,
    weight: {
      value: 100,
      measurement: 'g'
    },
    ratio: 100
  }
]

export default {
  getIngredients(cb) {
    setTimeout(() => cb(_ingredients), 100)
  }
}
